import { FlexAligner, Surface } from '@scaleaq/scaleui';
import { background, stroke } from '@scaleaq/sui-tokens/colors';
import { styled } from 'styled-components';

export const StyledOuterWrapper = styled(Surface)<{
  $padding: string;
  $borderRadius: string;
  $error?: boolean;
  $hideBorder: boolean;
}>`
  position: relative;
  width: 100%;
  height: 100%;
  padding: ${({ $padding }) => $padding};
  border-radius: ${({ $borderRadius }) => $borderRadius};
  border: ${({ $hideBorder, $error }) =>
    $hideBorder ? 'none' : `1px solid ${$error ? stroke.alarm[100] : stroke.neutral.solid[300]}`};
`;

export const StyledLoading = styled(FlexAligner)<{ $borderRadius: string; $loadingZIndex: number }>`
  z-index: ${({ $loadingZIndex }) => $loadingZIndex};
  position: absolute;
  border-radius: ${({ $borderRadius }) => $borderRadius};
  opacity: 0.8;
  background-color: ${background.neutral.soft[200]};
  inset: 0;
  flex: 1;
`;

export const StyledErrorContainer = styled(FlexAligner)<{
  $borderRadius: string;
  $errorZIndex: number;
}>`
  position: absolute;
  z-index: ${({ $errorZIndex }) => $errorZIndex};
  border-radius: ${({ $borderRadius }) => $borderRadius};
  background-color: ${background.alarm.soft[100]};
  inset: 0;
`;
